import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles.css'

const propTypes = {
  from: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
    }
  }

  componentDidCatch(error, errorInfo) {
    const { from } = this.props
    this.setState({ error })
    Raven.captureException(error, { extra: { from, errorInfo } })
  }

  render() {
    const { children } = this.props
    const { error } = this.state

    if (error) {
      return <p className={styles.errorPage}>Ett oväntat fel uppstod.</p>
    }

    return children
  }
}

ErrorBoundary.propTypes = propTypes



// WEBPACK FOOTER //
// ../source/components/ErrorBoundary/index.js